<template>
  <div class="login-dialog">
    <el-dialog
     :title="$t('prompt.title')"
     :visible="true"
     :close-on-click-modal="false"
     :close-on-press-escape="false"
     :show-close="false"
     @close="handleClose"
     width="460px"
    >
      <div class="login-box">
        <div style="line-height: 1.6em;">{{$t("recycle.recycle17")}}</div>
        <div style="line-height: 1.6em;">{{$t("recycle.recycle18")}}</div>
        <div style="line-height: 1.6em;">{{$t("recycle.recycle19")}}</div>

        <div style="line-height: 1.6em;color: #ff0000" @click="handleClick('item4')">{{$t("recycle.recycle20")}}</div>
        <div style="line-height: 1.6em;color: #ff0000" @click="handleClick('item5')">{{$t("recycle.recycle21")}}</div>

        <div style="line-height: 1.6em;">{{$t("recycle.recycle22")}}</div>

        <el-form ref="registerFormRef" :model="registerForm" label-width="0" :rules="registerFormRules" class="register_form">
          <el-form-item style="margin-bottom: 5px !important" prop="isAgree">
            <template>
              <el-checkbox v-model="checked"></el-checkbox>
            </template>
            <span>{{ $t('recycle.recycle23') }}</span>
          </el-form-item>
          <el-form-item style="margin-bottom: 5px !important" prop="isYs">
            <template>
              <el-checkbox v-model="checked2"></el-checkbox>
            </template>
            <span>{{ $t('recycle.recycle24') }}</span>
          </el-form-item>
        </el-form>

        <div slot="footer" class="" style="display: flex;justify-content: flex-end;">
          <el-button  class="form-btn btn-blue" @click="handleSave()">{{ $t('recycle.recycle25') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "login-dialog",
  data(){
    var validateIsAgree = (rule, value, callback) => {
      if (this.checked) {
        callback();
      } else {
        callback(new Error(this.$t('login.login27')));
      }
    };
    var validateIsYs = (rule, value, callback) => {
      if (this.checked2) {
        callback();
      } else {
        callback(new Error(this.$t('login.login37')));
      }
    };
    return{
      registerFormRules: {
        isAgree: [
          //{required:true,message:'请同意《用户协议》',trigger:'change'},
          { validator: validateIsAgree, trigger: 'change', required: true }
        ],
        isYs: [
          //{required:true,message:'请同意《用户协议》',trigger:'change'},
          { validator: validateIsYs, trigger: 'change', required: true }
        ]
      },
      registerForm: {},
      checked: false,
      checked2: false,
      agreementUrls: { terms: '', privacy: '' }, // 协议链接（从接口动态获取）
    }
  },
  mounted() {
    this.getData();
    this.getAgreementUrls();
  },
  methods: {
    async getData(){
      const { data: res } = await this.$http.get("admin/info");
      //用户名放入session
      sessionStorage.setItem("username", res.data.username);
    },
    async handleChange(a,b){
      if(a && b === 1){
        const params = {
          type: 1,
          readTimeLong: Date.now(),
          userId: window.sessionStorage.getItem('username'),
        }
        const res = await this.$http.post("customer/userRead", params);
        console.log(res)
      }
      if(a && b === 2){
        const params = {
          type: 2,
          readTimeLong: Date.now(),
          userId: window.sessionStorage.getItem('username'),
        }
        const res = await this.$http.post("customer/userRead", params);
        console.log(res)
      }

    },
    // 获取协议链接（利用规约、隐私政策）
    async getAgreementUrls(){
      try {
        const { data: res } = await this.$http.get('agreementConfig/getUrls');
        if (res.code == 200 && res.data) {
          const terms = res.data.find(item => item.type == 1);
          const privacy = res.data.find(item => item.type == 2);
          this.agreementUrls.terms = terms ? terms.url : '';
          this.agreementUrls.privacy = privacy ? privacy.url : '';
        }
      } catch (e) {
        console.error('获取协议链接失败', e);
      }
    },
    async handleClick(command){
      if (command === "item4") {
        if (this.agreementUrls.terms) {
          window.open(this.agreementUrls.terms)
        }
      }
      if (command === "item5") {
        if (this.agreementUrls.privacy) {
          window.open(this.agreementUrls.privacy)
        }
      }
    },
    handleSave(){
      this.$refs['registerFormRef'].validate(async (valid) => {
        if (valid) {
          if(this.checked){
            await this.handleChange(true,1)
          }
          if(this.checked2){
            await this.handleChange(true,2)
          }
          this.$options.confirm(true)
        }
      })
    },
    handleClose () {
      this.$options.cancel('cancel')
    }
  }
}
</script>

<style scoped lang="less">
.login-dialog{
  .login-box{

  }
}
.register_form{
  span{
    margin-left: 5px;
    cursor: pointer;
  }
}
</style>
